<template>
  <div id="page-about">
    <h1>about page</h1>           
  </div>
</template>




<script>
export default {
  name: "about"
}

</script>
